import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  FaPlus,
  FaShieldAlt,
  FaTrash,
  FaEdit,
  FaSortAmountUp,
  FaSortAmountDown,
  FaArrowLeft,
  FaArrowRight,
  FaChevronDown,
  FaMapMarkerAlt,
  FaSync,
  FaGlobe,
  FaHandshake,
  FaSearch,
  FaCheckCircle,
  FaTruck,
  FaCaretDown,
  FaWindowClose,
  FaDotCircle,
  FaEllipsisV,
  FaBoxes,
  FaPlusCircle,
  FaInfoCircle,
  FaCogs,
  FaSave,
  FaExclamationCircle,
  FaChevronUp,
  FaQuestionCircle,
} from "react-icons/fa";
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";

const Liste_fret_corbeille = ({ titre }) => {
  useAuth();
  const user_id = localStorage.getItem("userId");
  const navigate = useNavigate();

  // État pour les données et la gestion de la table
  const [frets, setFrets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [totalItems, setTotalItems] = useState(0);
  const [showInfo, setShowInfo] = useState(false);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    // setTimeout(() => {
    //   setAlert({ message: "", type: "" });
    // }, 3000);
  };

  const fermerNotif = () => {
    setAlert({ message: '', type: '' });
  }

  // Simuler le chargement des données
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-frets-corbeille/?page=${currentPage}&per_page=${itemsPerPage}`
      );
      if (response.ok) {
        const data = await response.json();
        setFrets(data.frets);
        setTotalItems(data.pagination.total);
      }
      setLoading(false);
    } catch (error) {
      console.error("Erreur lors du chargement des frets:", error);
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [currentPage, itemsPerPage]);

  // Fonction de tri
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
    fetchData(true);
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
    setCurrentPage(1);
    fetchData(true); // Force le rechargement
  };

  // Appliquer le tri et la recherche
  const sortedAndFilteredFrets = React.useMemo(() => {
    let filterableFrets = [...frets];

    // Filtre de recherche
    if (searchTerm) {
      filterableFrets = filterableFrets.filter(fret =>
        Object.values(fret).some(
          val => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    // Tri
    if (sortConfig.key) {
      filterableFrets.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filterableFrets;
  }, [frets, searchTerm, sortConfig]);

  // Gestion du changement d'éléments par page
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Réinitialiser à la première page
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedAndFilteredFrets.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedAndFilteredFrets.length / itemsPerPage);

  // Changer de page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Formater la date pour l'affichage
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };


  // États nécessaires
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fretToDelete, setFretToDelete] = useState(null);

  // Fonction de suppression
  const handleDeleteFret = async () => {
    if (!fretToDelete) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-fret/${fretToDelete.id}/${user_id}/`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        // Mettre à jour l'état local
        setFrets(frets.filter(f => f.id !== fretToDelete.id));
        showAlert('Fret supprimé avec succès', 'success');
      } else {
        const error = await response.json();
        showAlert(error.message || 'Erreur lors de la suppression', 'error');
      }
    } catch (error) {
      showAlert('Erreur réseau', 'error');
      console.error(error);
    } finally {
      setShowDeleteModal(false);
      setFretToDelete(null);
    }
  };





  const assignerCamionsAuFret = async (fretId) => {
    try {
      setLoading(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}/assigner-camions-au-fret/${fretId}/${user_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      console.log(data)

      if (!response.ok) {
        // Erreur principale
        let errorHtml = data.html ? data.error : `
          <strong>Erreur ${response.status}</strong><br>
          ${data.error || "Erreur inconnue"}
        `;

        // Ajout des détails s'ils existent
        if (data.details?.blocages?.length) {
          errorHtml += `
            <div class="mt-3">
              <strong>Détails :</strong>
              <ul class="mt-1">
                ${data.details.blocages.map(b => `<li>${b}</li>`).join('')}
              </ul>
            </div>
          `;
        }

        showAlert(errorHtml, 'danger');
        return;
      }

      // --- Message de succès ou avertissement
      const { statut, details = {}, success } = data;
      const { assignations = [], assignations_existantes = [], quotas_restants = {} } = details;

      let totalQuotas = data.details.quotas_totaux?.total_global || 0;

      let totalRestants = totalQuotas - (assignations.length + assignations_existantes.length);
      let motCamionAssignes = assignations.length > 1 ? 'camions assignés' : 'camion assigné';
      let motCamionRestants = totalRestants > 1 ? 'camions restants' : 'camion restant';

      let successHtml = success || `
        <div class="mt-2">
          ${assignations.length} sur un total de
          ${totalRestants} ${motCamionRestants} ont été assignés.
        </div>
      `;
      // let successHtml = success || `
      //   <div>
      //     <i class="fas fa-${statut === 'selection terminee' ? 'check' : 'exclamation'}-circle"></i>
      //     <strong>${statut === 'selection terminee' ? 'Assignation complète' : ''}</strong><br/>
      //   </div>
      //   <div class="mt-2">
      //     ${assignations.length} nouveau(x) camion(s) assigné(s)<br>
      //     ${assignations_existantes.length} camion(s) existant(s)<br>
      //     ${assignations.length + assignations_existantes.length} camion(s) au total
      //   </div>
      // `;

      // Liste camions existants
      // if (assignations_existantes.length > 0) {
      //   successHtml += `
      //     <div class="mt-2">
      //       <strong>Camions assignés :</strong>
      //       <ul class="mt-1">
      //         ${assignations_existantes.map(a => `<li>Camion ${a.immatriculation} (${a.type})</li>`).join('')}
      //       </ul>
      //     </div>
      //   `;
      // }

      // Liste nouveaux camions
      if (assignations.length > 0) {
        successHtml += `
          <div class="mt-2">
            <strong>Nouveaux camions :</strong>
            <ul class="mt-1">
              ${assignations.map(a => `<li>Camion ${a.immatriculation} (${a.type})</li>`).join('')}
            </ul>
          </div>
        `;
      }

      // Quotas restants
      // if (Object.keys(quotas_restants).length > 0) {
      //   successHtml += `
      //     <div class="mt-2">
      //       <strong>Quotas restants :</strong>
      //       <ul class="mt-1">
      //         ${Object.entries(quotas_restants).map(([categorie, quotas]) => `
      //           <li>
      //             ${categorie.replace(/_/g, ' ')} :
      //             ${Object.entries(quotas)
      //       .filter(([_, qty]) => qty > 0)
      //       .map(([type, qty]) => `${type} (${qty})`)
      //       .join(', ') || 'Tous quotas atteints'}
      //           </li>
      //         `).join('')}
      //       </ul>
      //     </div>
      //   `;
      // }

      showAlert(successHtml, statut === 'realisable' ? 'success' : 'warning');

      // --- Rafraîchir les frets
      try {
        // const updatedFrets = await fetchFrets();
        // if (updatedFrets) setFrets(updatedFrets);
        await fetchFrets()
      } catch (refreshError) {
        console.error("Erreur rafraîchissement:", refreshError);
        showAlert("Assignation réussie mais erreur lors du rafraîchissement", 'warning');
      }

    } catch (error) {
      console.error("Erreur réseau:", error);
      showAlert(`
        <div class="error-alert">
          <i class="fas fa-network-wired"></i>
          <strong>Erreur réseau</strong><br>
          Impossible de contacter le serveur
        </div>
      `, 'error');
    } finally {
      setLoading(false);
    }
  };




  // Fonction helper pour le rafraîchissement
  const fetchFrets = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-frets/", {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error("Erreur fetchFrets:", error);
      return null;
    }
  };






  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownItemStyle = {
    padding: '8px 12px',
    width: '100%',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  };

  const [showAuthorizationModal, setShowAuthorizationModal] = useState(false);
  const [fretAuthoriser, setFretAuthoriser] = useState(null);
  const [authoriserMessage, setAuthoriserMessage] = useState('');
  const [autorisationChoix, setAutorisationChoix] = useState('oui');
  const [sourceApprovisionnement, setSourceApprovisionnement] = useState('nationaux');

  const handleOuvrirAutorisationModal = (fret) => {
    setFretAuthoriser(fret);

    // Construire le message détaillé
    const message = `
      <div>
        <p>Souhaitez-vous autoriser l'utilisation de camions d'autres appartenances pour compléter ?</p>
      </div>
    `;

    setAuthoriserMessage(message);
    setShowAuthorizationModal(true);
  };



  const confirmAuthorization = async () => {
    if (!fretAuthoriser) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/autoriser/${fretAuthoriser.id}/${user_id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          autorise: autorisationChoix,
          source_approvisionnement: autorisationChoix === 'oui' ? sourceApprovisionnement : ''
        })
      });

      if (response.ok) {
        // Mettre à jour l'état local
        setFrets(frets.map(f =>
          f.id === fretAuthoriser.id ? { ...f, autorise: autorisationChoix } : f
        ));

        showAlert(`Autorisation "${autorisationChoix}" enregistrée avec succès`, 'success');

        // Si "oui", on peut tenter d'assigner les camions
        // await assignerCamionsAuFret(fretAuthoriser.id);
      } else {
        const error = await response.json();
        showAlert(error.message || "Erreur lors de l'autorisation", 'error');
      }
    } catch (error) {
      showAlert('Erreur réseau', 'error');
      console.error(error);
    } finally {
      setShowAuthorizationModal(false);
      setFretAuthoriser(null);
      setAutorisationChoix('oui'); // Réinitialiser le choix
    }
  };

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [fretToAssign, setFretToAssign] = useState(null);

  const handleAnnulerAssignation = async (fretId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/annuler-assignation-fret/${fretId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        showAlert(data.success);
        fetchData()
      } else {
        showAlert(data.error, 'danger');
      }
    } catch (error) {
      console.error('Erreur lors de l\'annulation');
    } finally {
      fetchData()
    }
    toggleDropdown(null);
  };

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedFretDetails, setSelectedFretDetails] = useState(null);

  const handleShowDetails = (fret) => {
    setSelectedFretDetails(fret);
    setShowDetailsModal(true);
  };


  const [showSpecQuotaModal, setShowSpecQuotaModal] = useState(false);
  const [activeTab, setActiveTab] = useState('spec');

  const handleOpenSpecQuotaModal = (fret) => {
    setFretSelectionne(fret);

    // Initialiser formData avec les données existantes du fret
    const initialFormData = {
      types_camions: fret.types_camions.map(t => t.id),
      nbre_type: {},
      charge_utile_par_type: {},
      quota_nationaux: {},
      quota_pays_destination: {},
      quota_bailleur: {},
      charge_utile_totale: fret.charge_utile_totale || 0
    };

    // Remplir les données pour chaque type de camion
    fret.types_camions.forEach(type => {
      const typeId = type.id.toString();

      // Calculer le nombre total de camions pour ce type
      const totalCamions =
        (fret.quotas.nationaux[typeId]?.valeur || 0) +
        (fret.quotas.pays_destination[typeId]?.valeur || 0) +
        (fret.quotas.bailleur[typeId]?.valeur || 0);

      initialFormData.nbre_type[typeId] = totalCamions;
      initialFormData.charge_utile_par_type[typeId] =
        fret.quotas.nationaux[typeId]?.charge_utile_par_camion ||
        fret.quotas.pays_destination[typeId]?.charge_utile_par_camion ||
        fret.quotas.bailleur[typeId]?.charge_utile_par_camion || 0;

      initialFormData.quota_nationaux[typeId] = fret.quotas.nationaux[typeId]?.valeur || 0;
      initialFormData.quota_pays_destination[typeId] = fret.quotas.pays_destination[typeId]?.valeur || 0;
      initialFormData.quota_bailleur[typeId] = fret.quotas.bailleur[typeId]?.valeur || 0;
    });

    setFormData(initialFormData);
    setShowSpecQuotaModal(true);
    setActiveTab('spec');
  };



  const [formData, setFormData] = useState({
    // Spécificités
    types_camions: [],

    // nbre type
    nbre_type: {},

    // charge utile
    charge_utile_totale: 0,
    charge_utile_par_type: {},

    // Quotas
    quota_nationaux: {},
    quota_pays_destination: {},
    quota_bailleur: {},

  });

  const [typesCamions, setTypesCamions] = useState([]);
  const handleTypesCamionsChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];

    // Créer un nouvel objet nbre_type avec les nouveaux types
    const newNbreType = {};
    selectedValues.forEach(typeId => {
      if (!formData.nbre_type[typeId]) {
        newNbreType[typeId] = 0;
      } else {
        newNbreType[typeId] = formData.nbre_type[typeId];
      }
    });

    setFormData(prev => ({
      ...prev,
      types_camions: selectedValues,
      nbre_type: newNbreType,
      quota_nationaux: {},
      quota_pays_destination: {},
      quota_bailleur: {}
    }));
  };

  const handleQuotaChange = (quotaType, camionType, value) => {
    setFormData(prev => ({
      ...prev,
      [quotaType]: {
        ...prev[quotaType],
        [camionType]: value ? parseInt(value) : 0
      }
    }));
  };

  const handleChargeUtileChange = (typeId, value) => {
    const chargeUtile = parseFloat(value) || 0;

    setFormData(prev => ({
      ...prev,
      charge_utile_par_type: {
        ...prev.charge_utile_par_type,
        [typeId]: chargeUtile
      }
    }));
  };

  const handleNbreTypeChange = (typeId, value) => {
    const nbreCamions = value ? parseInt(value) : 0;

    setFormData(prev => ({
      ...prev,
      nbre_type: {
        ...prev.nbre_type,
        [typeId]: nbreCamions
      }
    }));
  };

  const fetchTypesCamions = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-types/");
      if (response.ok) {
        const data = await response.json();

        const filteredTypes = data
          .filter(type => type.option !== 'Tete')
          .map(type => ({
            value: type.id,
            label: type.libelle
          }));

        setTypesCamions(filteredTypes);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des types de camions:", error);
    }
  };

  useEffect(() => {
    fetchTypesCamions();
  }, []);


  const [fretSelectionne, setFretSelectionne] = useState(null);
  const reserverTransport = async () => {
    try {
      // Préparer les données pour l'envoi
      const requestData = {
        fret_id: fretSelectionne.id,
        types_camions: formData.types_camions,
        charge_utile_totale: formData.charge_utile_totale,
        charge_utile_par_type: formData.charge_utile_par_type,
        nbre_type: formData.nbre_type,
        quotas: {
          nationaux: formData.quota_nationaux,
          pays_destination: formData.quota_pays_destination,
          bailleur: formData.quota_bailleur
        }
      };

      const response = await fetch(`${process.env.REACT_APP_HOTE}/reserver-transport/${user_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(requestData)
      });

      const data = await response.json();

      if (response.ok) {
        showAlert(data.success)
        fetchData()
      } else {
        showAlert(data.error, 'danger')
      }

      console.log(requestData)

    } catch (error) {
      console.error("Erreur lors de la réservation:", error);
    } finally {
      setShowSpecQuotaModal(false)
    }
  };


  const calculateTotalQuotasRestant = (fret) => {
    let total = 0;

    // Vérifier si les quotas_restants existent
    if (!fret.quotas_restants) return 0;

    // Somme des quotas nationaux restants
    if (fret.quotas_restants.nationaux) {
      total += Object.values(fret.quotas_restants.nationaux)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    // Somme des quotas internationaux restants
    if (fret.quotas_restants.pays_destination) {
      total += Object.values(fret.quotas_restants.pays_destination)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    // Somme des quotas bailleur restants
    if (fret.quotas_restants.bailleur) {
      total += Object.values(fret.quotas_restants.bailleur)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    return total;
  };

  const [showGlossary, setShowGlossary] = useState(false);

  const [accesGroupes, setAccesGroupes] = useState([]);
      const [groupeId, setGroupeId] = useState(null);
      const groupe = localStorage.getItem('groupe_id');
  
      const verifGroupe = async () => {
          const groupeStored = localStorage.getItem('groupe_id');
          const accesGroupeStored = localStorage.getItem('accesGroupe');
  
          if (groupeStored && accesGroupeStored) {
              setGroupeId(groupeStored);
              setAccesGroupes(JSON.parse(accesGroupeStored));
          } else {
              try {
                  const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                  if (response.status === 200) {
                      const data = response.data;
                      setGroupeId(data.groupe);
  
                      let cleanedAccessArray = [];
                      if (Array.isArray(data.acces)) {
                          cleanedAccessArray = data.acces.map((item) =>
                              item.acces
                                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                  : []
                          ).flat();
  
                          setAccesGroupes(cleanedAccessArray);
                      }
  
                      localStorage.setItem('groupe', data.groupe);
                      localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                  }
              } catch (error) {
                  // console.error('Erreur lors de la vérification du groupe', error);
              }
          }
      };
  
      useEffect(() => {
          if (user_id) {
              verifGroupe();
          }
      }, [user_id]);
  
      if (!accesGroupes.includes("Corbeille")) {
          return (
              <Pas_acces />
          );
      }

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <FaBoxes size={25} className="mr-2" />
                  Corbeille des frets
                  {/* <span
                    className="ml-3 toggle-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowInfo(!showInfo)}
                  >
                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                  </span> */}
                </div>

                {/* Bouton d'aide complètement à droite */}
                {/* <button
                  className="btn btn-link p-0 ml-2"
                  title="Manuel d'utilisation"
                  onClick={() => navigate('/Manuel-utilisation-admin', {
                    state: {
                      fromModule: 'administration',
                      fromSection: 'admin-corbeille'
                    }
                  })}
                >
                  <FaQuestionCircle size={18} />
                </button> */}
                <button
                  className="btn btn-link p-0 ml-2"
                  title="Aide"
                  onClick={() => setShowGlossary(true)}
                >
                  <FaQuestionCircle size={18} />
                </button>
              </h2>
              <small>Corbeilles des frets.</small>
              <div className={`info-box ${showInfo ? "open" : ""}`}>
                {/* <small>Gestion des frets.</small><br /> */}
                <small><b>Légende : </b><br />
                  <span className='badge badge-danger'>Corbeille</span> <span>Le fret a été supprimé.</span><br />
                </small>
              </div>

              {/* <small>Liste des déclarations de fret.</small> */}

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                      <Link to={`/Menu`}> Accueil</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item active">
                    <Link to={`/Admin`}> Administration</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item active">
                    <Link to={`/Corbeilles`}> Corbeilles</Link>
                  </li>
                  <li className="breadcrumb-item custom-breadcrumb-item">
                     Corbeille des frets
                  </li>
                </ol>
              </small>
            </div>
          </div>

          {alert.message && (
            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
              <div
                // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                dangerouslySetInnerHTML={{ __html: alert.message }}
              />

              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                  right: '10px', // Ajustez l'espacement comme vous le souhaitez
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <div className="wrapper wrapper-content animated fadeInRight mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Liste des frets supprimés</h5>
            </div>
            <div className="ibox-content">

              {/* Barre de recherche et sélection d'éléments par page */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="me-2">
                  <select
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="form-select bg-default p-1"
                    style={{
                      width: "auto",
                      border: "1px black solid",
                      borderRadius: "5px",
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <input
                  type="text"
                  placeholder="Rechercher..."
                  className="form-control"
                  style={{ maxWidth: "150px", width: "100%" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Tableauuuuuuuuuuuuuuuuuuuuuuuuuuuuuu */}
              <div className="table-responsive">
                <table
                  className="footable table table-stripped footable-loaded tablet breakpoint"
                  data-page-size={itemsPerPage}
                >
                  <thead>
                    <tr>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('ref')}>
                        Ref
                        {sortConfig.key === 'ref'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('type_fret')}>
                        Type fret
                        {sortConfig.key === 'type_fret'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('designation')}>
                                      Désignation
                                      {sortConfig.key === 'designation'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                    </th> */}

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('nature')}>
                                      Nature
                                      {sortConfig.key === 'nature'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                    </th>
              
                                    <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('conteneurise')}>
                                      Conteneurisé
                                      {sortConfig.key === 'conteneurise'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                    </th> */}

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('nom_bailleur')}>
                        Bailleur
                        {sortConfig.key === 'nom_bailleur'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('destinataire')}>
                        Destinataire
                        {sortConfig.key === 'destinataire'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('trajet')}>
                        Trajet
                        {sortConfig.key === 'trajet'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_depart')}>
                        Date départ
                        {sortConfig.key === 'date_depart'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_arrivee')}>
                        Date arrivée
                        {sortConfig.key === 'date_arrivee'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('statut')}>
                        Etape
                        {sortConfig.key === 'statut'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('total_quotas')}>
                        Camions restants
                        {sortConfig.key === 'total_quotas'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('total_quotas')}>
                        Ajouté par
                        {sortConfig.key === 'total_quotas'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      {/* <th className="text-center">Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading && currentPage === 1 ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden"></span>
                          </div>
                        </td>
                      </tr>
                    ) : frets.length > 0 ? (
                      frets.map((fret) => (
                        <tr key={fret?.id}>
                          <td className="d-none d-md-table-cell text-justify">
                            {fret?.ref}
                          </td>
                          <td className="d-none d-md-table-cell text-justify">
                            {fret?.type_fret === 'national' ? 'National' : 'International'}
                          </td>
                          {/* <td className="d-none d-md-table-cell text-justify">
                        {fret.marchandises?.length > 0 ? fret.marchandises[0].designation : 'N/A'}
                      </td> */}
                          {/* <td className="d-none d-md-table-cell text-justify">
                        {fret.marchandises?.length > 0 ? (
                          fret.marchandises[0].nature === 'liquide' ? 'Liquide' :
                            fret.marchandises[0].nature === 'solide' ? 'Solide' :
                              fret.marchandises[0].nature === 'frais' ? 'Frais' : 'N/A'
                        ) : 'N/A'}
                      </td>
                      <td className="d-none d-md-table-cell text-justify">
                        {fret.marchandises?.length > 0 ?
                          (fret.marchandises[0].conteneurise === 'oui' ? 'Oui' : 'Non')
                          : 'N/A'}
                      </td> */}
                          <td className="d-none d-md-table-cell text-justify">
                            {fret?.bailleur?.nom || 'N/A'}
                          </td>
                          <td className="d-none d-md-table-cell text-center">{fret?.nom_destinataire}</td>
                          <td className="d-none d-md-table-cell text-center">
                            <small>
                              {/* <FaMapMarkerAlt />  */}
                              {fret?.ville_depart}
                              <FaArrowRight className="mx-2" />
                              {fret?.ville_arrivee}
                            </small>
                          </td>
                          <td className="d-none d-md-table-cell text-justify">{new Date(fret?.date_depart).toLocaleDateString()}</td>
                          <td className="d-none d-md-table-cell text-justify">{new Date(fret?.date_arrivee).toLocaleDateString()}</td>
                          <td className="d-none d-md-table-cell text-center">
                            {fret?.statut === 'Corbeille' && (
                              <span className="badge badge-danger">Corbeille</span>
                            )}
                          </td>
                          <td className="d-none d-md-table-cell text-center">
                            {calculateTotalQuotasRestant(fret)}
                          </td>
                          <td className="d-none d-md-table-cell text-center">
                            {fret?.utilisateur?.nom} {fret?.utilisateur?.prenoms}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center text-muted">
                          Aucun fret à afficher
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="dataTables_info" role="status" aria-live="polite">
                    {loading ? (
                      "Chargement..."
                    ) : frets.length === 0 ? (
                      "Aucun élément à afficher"
                    ) : (
                      `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)
                      } sur ${totalItems}`
                    )}
                  </div>

                  {totalItems > itemsPerPage && (
                    <div>
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="btn btn-light mx-1"
                      >
                        <FaArrowLeft />
                      </button>

                      {Array.from(
                        { length: Math.ceil(totalItems / itemsPerPage) },
                        (_, i) => i + 1
                      )
                        .filter(page =>
                          page === 1 ||
                          page === Math.ceil(totalItems / itemsPerPage) ||
                          Math.abs(page - currentPage) <= 2
                        )
                        .map((page, i, array) => (
                          <React.Fragment key={page}>
                            <button
                              onClick={() => setCurrentPage(page)}
                              className={`btn ${currentPage === page ? "btn-default" : "btn-light"
                                } mx-1`}
                            >
                              {page}
                            </button>
                            {array[i + 1] > page + 1 && <span className="mx-1">...</span>}
                          </React.Fragment>
                        ))}

                      <button
                        onClick={() => setCurrentPage(prev => prev + 1)}
                        disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
                        className="btn btn-light mx-1"
                      >
                        <FaArrowRight />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer"
          style={{
            zIndex: -1,
          }}>
          <div>
            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer">ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer">INOVACT SARL</a>
          </div>
        </div>
      </div>
      <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
    </div>
  );
};

export default Liste_fret_corbeille;